import { Fragment, useState } from "react";
import { Plus, Search, X } from "react-feather";
import { Form, Input } from "reactstrap";
import { Href } from "../../../../../Constants/Constants";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { closeLeftSide } from "../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { CommonLeftHeadingType } from "../../../../../Types/MessengerType";

const CommonLeftHeading: React.FC<CommonLeftHeadingType> = ({ title, sunTitle, search, modalToggle }) => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  return (
    <div className="template-title">
      <div className="d-flex">
        <div>
          <h3>{title}</h3>
          <h5>{sunTitle}</h5>
        </div>
        <div className="flex-grow-1">
          {search && (
            <Fragment>
              <a className="icon-btn btn-outline-light btn-sm m-r-15 search" href={Href} onClick={() => setOpen(!open)}>
                <Search />
              </a>
              <Form className={`form-inline search-form ${open && "open"}`}>
                <div className="form-group">
                  <Input className="form-control-plaintext" type="search" placeholder="Search.." />
                  <div className="icon-close close-search" onClick={() => setOpen(!open)}>
                    <X />
                  </div>
                </div>
              </Form>
            </Fragment>
          )}
          {modalToggle && (
            <a className="icon-btn btn-outline-light btn-sm m-r-15" href={Href} onClick={modalToggle}>
              <Plus />
            </a>
          )}
          <a className="icon-btn btn-outline-light btn-sm close-panel" href={Href} onClick={() => dispatch(closeLeftSide())}>
            <X />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CommonLeftHeading;
